// extracted by mini-css-extract-plugin
module.exports = {"search":"styles_search__3_hK4","header":"styles_header__LBbPo"};